<ng-template [ngIf]="tabsView" [ngIfElse]="fullView">
    <div class="d-flex align-items-center justify-content-between mb-4 navigator">
        <button nbButton status="dark" (click)="previousPhase()">
            <nb-icon icon="arrow-ios-back-outline"></nb-icon>
            <span>{{ "GAME.PREVIOUS-PHASE" | translate }}</span>
        </button>
        <div>
            <span class="paragraph" *ngIf="activeView.titulo_sub_caixa">{{ activeView.titulo_sub_caixa }}</span>
        </div>
        <button nbButton status="dark" (click)="nextPhase()">
            <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
           <span>{{ "GAME.NEXT-PHASE" | translate }}</span>
        </button>
    </div>
    <div class="overflow-auto h-100 w-100">
        <div class="cup-body">
            <div class="jQBracket lr" *ngIf="gamesDivided">
                <div class="bracket">
                    <ng-container *ngFor="let phase of gamesDivided">
                        <div class="round">
                            <div
                                class="match"
                                [class.match-h2h]="game.h2h && !game.jogo_com_bye"
                                [class.match-no-h2h]="!game.h2h || game.jogo_com_bye"
                                *ngFor="let game of phase.dados_sub_caixa; let index = index"
                                (click)="openMatchDetails(game)"
                            >
                                <div
                                    class="teamContainer"
                                    *ngFor="let participantGroup of game.participantGroup"
                                    [class.duplas]="participantGroup.duplas"
                                >
                                    <div
                                        [ngClass]="[
                                            'team',
                                            game.lado_vencedor === participantGroup.lado ? 'win' : 'lose'
                                        ]"
                                        data-teamid="0"
                                    >
                                        <div class="d-flex flex-wrap align-items-center">
                                            <div class="flex-1 d-flex flex-wrap">
                                                <div
                                                    class="label"
                                                    *ngFor="let participant of participantGroup.participants"
                                                >
                                                    {{ participant.nome }}
                                                </div>
                                            </div>
                                            <div
                                                [ngClass]="{
                                                    score: true,
                                                    'score-winner': result.resultado_vencedor == participantGroup.lado,
                                                    'score-tiebreak': result.tipo_set === '1'
                                                }"
                                                data-resultid="result-1"
                                                *ngFor="let result of participantGroup.result"
                                            >
                                                {{
                                                    result.resultado || result.resultado === ""
                                                        ? result.resultado
                                                        : result
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #fullView>
    <div class="cup-body full" #container (mousedown)="mouseDownHandler($event)">
        <div class="d-flex justify-content-around">
            <h2 *ngFor="let phaseHeader of headers">{{ phaseHeader.titulo_sub_caixa }}</h2>
        </div>
        <div class="jQBracket lr" *ngIf="gamesDivided">
            <div class="bracket">
                <ng-container *ngFor="let phase of gamesDivided">
                    <div [class]="roundFullSizeClass(phase)">
                        <div class="match" *ngFor="let game of phase.dados_sub_caixa; let index = index">
                            <div class="teamContainer" *ngFor="let participantGroup of game.participantGroup">
                                <div
                                    [ngClass]="['team', game.lado_vencedor === participantGroup.lado ? 'win' : 'lose']"
                                    data-teamid="0"
                                >
                                    <div class="d-flex align-items-center">
                                        <div class="label" *ngFor="let participant of participantGroup.participants">
                                            {{ participant.nome }}
                                        </div>
                                        <div
                                            data-resultid="result-1"
                                            *ngFor="let result of participantGroup.result"
                                            [ngClass]="{
                                                score: true,
                                                'score-winner': result.resultado_vencedor == participantGroup.lado,
                                                'score-tiebreak': result.tipo_set === '1'
                                            }"
                                        >
                                            {{
                                                result.resultado || result.resultado === "" ? result.resultado : result
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- IMPAR -->
                            <!-- <ng-container *ngIf="index % 2 !== 0">
                                        <div
                                            class="connector"
                                            style="
                                                height: 97.5px;
                                                width: 90px;
                                                right: -92px;
                                                bottom: 91px;
                                                border-top: none;
                                            "
                                        >
                                            <div class="connector" style="width: 90px; right: -90px; top: 0px"></div>
                                        </div>
                                    </ng-container> -->
                            <!-- PAR -->
                            <!-- <ng-container *ngIf="index % 2 === 0">
                                        <div
                                            class="connector"
                                            style="
                                                height: 97.5px;
                                                width: 90px;
                                                right: -92px;
                                                top: 101px;
                                                border-bottom: none;
                                            "
                                        >
                                            <div class="connector" style="width: 90px; right: -90px; bottom: 0px"></div>
                                        </div>
                                    </ng-container> -->
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>
